import Swal from "sweetalert2";
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
  url_json = url_json.local;
} else {
  url_json = url_json.production;
}

const Baners = {
  agregarBaner: async (data) => {
    let url = url_json + "/baner";
    let body = {
      titulo: data.titulo,
      tipo: Number(data.tipo),
      posicion: Number(data.posicion),
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();

    if (response.ok) {
      Swal.fire(
        "Inserción exitosa!",
        "Banner agregado correctamente",
        "success"
      );
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar el banner, codigo: " + res.message,
        "error"
      );
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
  obtenerBaners: async () => {
    let url = url_json + "/baner";
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerConfiguracionBaners: async () => {
    let url = url_json + "/baner/configuracion";
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  editarBaner: async (data, id) => {
    let url = url_json + "/baner/" + id;
    // El tipo no se edita
    let body = {
      titulo: data.titulo,
      posicion: Number(data.posicion),
    };
    let request = {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();

    if (response.ok) {
      Swal.fire(
        "Modificación exitosa!",
        "Banner modificado correctamente",
        "success"
      );
    } else {
      Swal.fire("Error!", "No se pudo modificar el banner", "error");
    }
    return { success: response.ok, data: res.data };
  },
  editarConfiguracionBaner: async (data) => {
    let url = url_json + "/baner/configuracion";
    let body = {
      modo: data.modo,
      fecha: data.fecha,
      color: data.color,
    };
    let request = {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();

    if (response.ok) {
      Swal.fire(
        "Modificación exitosa!",
        "Configuración actualizada correctamente",
        "success"
      );
    } else {
      Swal.fire("Error!", "No se pudo actualizar la configuración", "error");
    }
    return { success: response.ok, data: res.data };
  },
  eliminarBaner: async (id) => {
    let url = url_json + "/baner/delete/" + id;
    let request = {
      method: "PATCH",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();

    if (response.ok) {
      Swal.fire(
        "Eliminación exitosa!",
        "Banner eliminado correctamente",
        "success"
      );
    } else {
      Swal.fire("Error!", "No se pudo eliminar el banner", "error");
    }
    return { success: response.ok, data: res.data };
  },
};

export default Baners;
